  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import IconButton                                          from '@material-ui/core/IconButton';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import Typography                                          from '@material-ui/core/Typography';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[FAB]
  import Fab                                                 from '@material-ui/core/Fab';
  import CallIcon                                            from '@material-ui/icons/Call';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //----------
  // Libraries
  //----------
  import Cookies                                             from 'js-cookie';
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_CurrenciesService }                            from "../../_services";
  import { wu_FeeInquiryService }                            from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
  import { wu_ServiceAvailabilityService }                   from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import TransferOnline1Style                                from "./TransferOnline1Style.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import WU_STEPS_estimate_active                            from "assets/img/wu/WU_STEPS_estimate_active.svg";
//import WU_STEPS_estimate_inactive                          from "assets/img/wu/WU_STEPS_estimate_inactive.svg";
//import WU_STEPS_progress_symbol_active                     from "assets/img/wu/WU_STEPS_progress_symbol_active.svg";
  import WU_STEPS_progress_symbol_inactive                   from "assets/img/wu/WU_STEPS_progress_symbol_inactive.svg";
//import WU_STEPS_recipient_active                           from "assets/img/wu/WU_STEPS_recipient_active.svg";
  import WU_STEPS_recipient_inactive                         from "assets/img/wu/WU_STEPS_recipient_inactive.svg";
//import WU_STEPS_review_active                              from "assets/img/wu/WU_STEPS_review_active.svg";
  import WU_STEPS_review_inactive                            from "assets/img/wu/WU_STEPS_review_inactive.svg";
//import WU_STEPS_sender_active                              from "assets/img/wu/WU_STEPS_sender_active.svg";
  import WU_STEPS_sender_inactive                            from "assets/img/wu/WU_STEPS_sender_inactive.svg";

  import WU_PAYMENT_bank_active                              from "assets/img/wu/WU_PAYMENT_bank_active.svg";
  import WU_PAYMENT_bank_inactive                            from "assets/img/wu/WU_PAYMENT_bank_inactive.svg";
  import WU_PAYMENT_card_active                              from "assets/img/wu/WU_PAYMENT_card_active.svg";
  import WU_PAYMENT_card_inactive                            from "assets/img/wu/WU_PAYMENT_card_inactive.svg";
  import WU_PAYMENT_cash_active                              from "assets/img/wu/WU_PAYMENT_cash_active.svg";
  import WU_PAYMENT_cash_inactive                            from "assets/img/wu/WU_PAYMENT_cash_inactive.svg";

  import WU_FORM_compare                                     from "assets/img/wu/WU_FORM_compare.svg";

  import WU_FORM_add_plus_expand                             from "assets/img/wu/WU_FORM_add_plus_expand.svg";
  import WU_FORM_add_minus_retract                           from "assets/img/wu/WU_FORM_add_minus_retract.svg";

//import WU_Card_logos_visa                                  from "assets/img/wu/cards/vbv.jpg";
//import WU_Card_logos_mastercard                            from "assets/img/wu/cards/sc_68x37.gif";
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";

  //----------
  // variables
  //----------
  const filename = "TransferOnline1 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[flagsimages]
  var images = null;

//let aRegex = /^\d{0,9}(?:\.\d{0,2}){0,1}$/;  //dot
  let aRegex = /^\d{0,9}(?:,\d{0,2}){0,1}$/;   //comma

  //[Lockers]
  var TransferOnline1_continue_locked = true;

class TransferOnline1 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let viewSteps3_view_isHidden = false;
    let viewSteps4_view_isHidden = true;

    wu_Utilities.clearTransaction();

    localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_send);
    localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
    localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Cash);
    localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      viewSteps3_view_isHidden                             : viewSteps3_view_isHidden,
      viewSteps3_lbl_lbl1                                  : "",
      viewSteps3_lbl_lbl2                                  : "",
      viewSteps3_lbl_lbl3                                  : "",

      viewSteps4_view_isHidden                             : viewSteps4_view_isHidden,
      viewSteps4_lbl_lbl1                                  : "",
      viewSteps4_lbl_lbl2                                  : "",
      viewSteps4_lbl_lbl3                                  : "",
      viewSteps4_lbl_lbl4                                  : "",

      picker1_selIndex                                     : 0,  //Country
      picker1_textFieldLabel1_id                           : "",
      picker1_textFieldLabel1_text                         : "",
      picker1_textFieldLabel1_hasError                     : false,
      picker1_textFieldLabel1_AUTOCOMPLETE_MODE            : "object", //"text","object";
      picker1_textFieldLabel1_AUTOCOMPLETE_FILTER_OPTIONS  : "any",    //"start","any"
      picker2_selIndex_currencySend                        : 0,  //2-Send Currency
      picker2_textFieldLabel1_text                         : "Euro",
      picker2_textFieldLabel1_id                           : "EUR",
      picker3_selIndex_currencyReceive                     : 0,  //3-Receive Currency
      picker3_textFieldLabel1_id                           : "",
      picker3_textFieldLabel1_text                         : "",
      picker3_textFieldLabel1_hasError                     : false,
      picker4_selIndex_State                               : 0,  //4-State
      picker4_textFieldLabel1_text                         : "",
      picker4_textFieldLabel1_id                           : "",
      picker5_selIndex_City                                : 0,  //5-City
      picker5_textFieldLabel1_text                         : "",
      picker5_textFieldLabel1_id                           : "",

      viewState_isHidden                                   : true,
      viewCity_isHidden                                    : true,
      viewStateCity_isHidden                               : true,

      textFieldYouSend                                     : "",
      textFieldYouSend_hasError                            : false,
      textFieldYouSend_disabled                            : false,
      textFieldReceiverGets                                : "",
      textFieldReceiverGets_hasError                       : false,
      textFieldReceiverGets_disabled                       : true,

      picker6_textFieldLabel1                              : "", //6-TranferMethod
      picker7_textFieldLabel1                              : "", //7-PaymentMethod

      viewTM_view_CM_isHidden                              : false,
      viewTM_view_BA_isHidden                              : true,

      PM_BT_image                                          : WU_PAYMENT_bank_active,
      PM_CC_image                                          : WU_PAYMENT_card_inactive,
      TM_CM_image                                          : WU_PAYMENT_cash_active,
      TM_BA_image                                          : WU_PAYMENT_bank_inactive,

      viewRN_isHidden                                      : true,

      viewExp_lbl_val1                                     : "",
      viewExp_lbl_val2                                     : "",
      viewExp_lbl_val3                                     : "",
      viewExp_lbl_val3_show                                : true,
      viewExp_lbl_val4                                     : "",
      viewExp_lbl_val5                                     : "",

      btn_next_state                                       : "",

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getCities                               : [],
      parserObject_getCities4Picker                        : [],
      parserObject_getStates                               : [],
      parserObject_getStates4Picker                        : [],
      parserObject_getCurrencies_ALL                       : [],
      parserObject_getCurrencies                           : [],
      parserObject_getCurrencies4Picker                    : [],

      parserObject_getfeeinquirymultiple                   : {},

      TransferOnline1_type                                 : api.TransferOnline1_type_send,
      TransferOnline1_PaymentMethod                        : api.TransferOnline1_PaymentMethod_BankTransfer,
      TransferOnline1_TransferMethod                       : api.TransferOnline1_TransferMethod_Cash,
      promo_type_selected                                  : api.promo_type_selected_none,

      WU_FORM_promo_openclose_img                          : WU_FORM_add_plus_expand,
      promo_isHidden                                       : true,
      textField100                                         : "", //promoCode

      //popup checkAppVersion
      dialog_checkAppVersion_isOpen                        : false,
      dialog_checkAppVersion_msg                           : "",

      //[FAB]
      fab_isHidden                                         : true,
      dialog100_msg                                        : "",
      dialog100_isOpen                                     : false,

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                             = this.isLockersActive.bind(this);
    this.startLockers                                                = this.startLockers.bind(this);
    this.stopLockers                                                 = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.handleCustomDropDownClick_country                           = this.handleCustomDropDownClick_country.bind(this);
    this.handleCustomDropDownClick_state                             = this.handleCustomDropDownClick_state.bind(this);
    this.handleCustomDropDownClick_city                              = this.handleCustomDropDownClick_city.bind(this);
    this.handleCustomDropDownClick_currency                          = this.handleCustomDropDownClick_currency.bind(this);

    this.PM_BT_act                                                   = this.PM_BT_act.bind(this);
    this.PM_CC_act                                                   = this.PM_CC_act.bind(this);
    this.TM_CM_act                                                   = this.TM_CM_act.bind(this);
    this.TM_BA_act                                                   = this.TM_BA_act.bind(this);

    this.btn_arrows_act                                              = this.btn_arrows_act.bind(this);

    this.btn_next_act                                                = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                     = this.btn_next_act_isDisabled.bind(this);
    this.makeHTTPConn_next                                           = this.makeHTTPConn_next.bind(this);
    this.calculateFeeInquiryMultiple                                 = this.calculateFeeInquiryMultiple.bind(this);
    this.setup_Expenses_and_global_promo                             = this.setup_Expenses_and_global_promo.bind(this);
    this.promo_find_default_item                                     = this.promo_find_default_item.bind(this);

    this.makeHTTPConn_select_COUNTRY_reload_STATE                    = this.makeHTTPConn_select_COUNTRY_reload_STATE.bind(this);
    this.makeHTTPConn_select_STATE_reload_CITY                       = this.makeHTTPConn_select_STATE_reload_CITY.bind(this);
    this.updateUI_select_COUNTRY_reload_CURRENCY                     = this.updateUI_select_COUNTRY_reload_CURRENCY.bind(this);

    this.handleSubmit_with_recaptcha                                 = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                = React.createRef();

    this.getCurrenciesWebServices                                    = this.getCurrenciesWebServices.bind(this);
    this.serviceAvailability                                         = this.serviceAvailability.bind(this);
    this.repeatTransaction                                           = this.repeatTransaction.bind(this);
    this.cookiesFromSite                                             = this.cookiesFromSite.bind(this);

    this.WU_FORM_promo_openclose_act                                 = this.WU_FORM_promo_openclose_act.bind(this); //Promo

    //popup checkAppVersion
    this.dialog_checkAppVersion_handleOpen                           = this.dialog_checkAppVersion_handleOpen.bind(this);
    this.dialog_checkAppVersion_btn_ok                               = this.dialog_checkAppVersion_btn_ok.bind(this);

    //[FAB]
    this.fab_geoLocateIP                                             = this.fab_geoLocateIP.bind(this);
    this.fab_Click2CallAction                                        = this.fab_Click2CallAction.bind(this);
    this.dialog100_handleOpen                                        = this.dialog100_handleOpen.bind(this);
    this.dialog100_handleClose                                       = this.dialog100_handleClose.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                        = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                       = this.dialog101_handleClose.bind(this);

    //if(api.print_logs){console.log("validateFloatString(100.00) = "+wu_Utilities.validateFloatString(wu_Utilities.convert2FloatString("100.00")));}
    //if(api.print_logs){console.log("validateFloatString(100,00) = "+wu_Utilities.validateFloatString(wu_Utilities.convert2FloatString("100,00")));}
    //if(api.print_logs){console.log("validateFloatString(100)    = "+wu_Utilities.validateFloatString(wu_Utilities.convert2FloatString("100")));}
    //if(api.print_logs){console.log("validateFloatString(100.00) = "+wu_Utilities.validateFloatString("100.00"));}
    //if(api.print_logs){console.log("validateFloatString(100,00) = "+wu_Utilities.validateFloatString("100,00"));}
    //if(api.print_logs){console.log("validateFloatString(100)    = "+wu_Utilities.validateFloatString("100"));}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        //++++++++++++
        //Login Screen
        //++++++++++++
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //[Lockers]
    this.stopLockers();

    //-------------
    //Do some reset
    //-------------
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("LoginPage_flow",          "false");      } catch(err){;}
    try { localStorage.setItem("TransferOnlineLogin_flow","false");      } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");             } catch(err){;}
    try { localStorage.setItem("CustomerWantedToLoginToBills", "false"); } catch(err){;}

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="TransferOnline2"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}

      try{
        let t1State = JSON.parse(localStorage.getItem(filename.trim()));
        //console.log("localStorage.getItem(filename.trim())="+localStorage.getItem(filename.trim()));
        localStorage.setItem("TransferOnline1_type",          t1State.TransferOnline1_type);
        localStorage.setItem("TransferOnline1_PaymentMethod", t1State.TransferOnline1_PaymentMethod);
        localStorage.setItem("TransferOnline1_TransferMethod",t1State.TransferOnline1_TransferMethod);
        localStorage.setItem("promo_type_selected",           t1State.promo_type_selected);
        //console.log("t1State.TransferOnline1_type           = "+t1State.TransferOnline1_type);
        //console.log("t1State.TransferOnline1_PaymentMethod  = "+t1State.TransferOnline1_PaymentMethod);
        //console.log("t1State.TransferOnline1_TransferMethod = "+t1State.TransferOnline1_TransferMethod);
        //console.log("t1State.promo_type_selected            = "+t1State.promo_type_selected);
      }catch(err){;}
      return;
    }

    this.setState({
      "picker6_textFieldLabel1" : this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1"), //6-TranferMethod
      "picker7_textFieldLabel1" : this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1"), //7-PaymentMethod
      "btn_next_state"          : this.NSInforString("TransferOnline_btn_calc")
    });

    //nailed for testing:START---inactive
    //wu_Utilities.printSomeValuesFromLocalStorage();
    //nailed for testing:END

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //nailed for testing:START---inactive
    //localStorage.removeItem("countries");
    //localStorage.removeItem("currencies");
    //nailed for TESTING:END
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
        this.getCurrenciesWebServices();
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
        this.getCurrenciesWebServices();
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        res.countries = this.removeNonWuCountries(res.countries);
        res.countries = wu_Utilities.addKeywordsToJSON_test(res.countries);
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
        this.getCurrenciesWebServices();
      }catch(err){
        console.log('err='+err);
      }
    }

    //[FAB]
    this.fab_geoLocateIP();

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      console.log("campaigns window.innerWidth="+window.innerWidth);
      if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
      else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
      this.dialog101_handleOpen("");
    }
  }
  //----------------------------------------------------------------------------------------------------
  //[FAB]
  fab_geoLocateIP(){
    let methName = "fab_geoLocateIP";
    //SOS TODO cache for a certain period
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.setState({ "fab_isHidden":false }); return; }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    let phonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocation({}) //FAB
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_geolocation",JSON.stringify(res.location));
      let ws_country = "";
      try {ws_country = res.location["country"]; }catch(err){;} if(ws_country === null || (typeof ws_country ==="undefined")){ws_country = "";}
      for(let i=0; i<phonePrefixes.phone_prefixes.length; ++i){
        if(phonePrefixes.phone_prefixes[i]["descr"].indexOf(ws_country)>=0){
          localStorage.setItem("IPCOUNTRY",           phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          localStorage.setItem("UserSelectedCountry", phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          break;
        }
      }
      //console.log(methName+"IPCOUNTRY="+localStorage.getItem("IPCOUNTRY"));
      if(localStorage.getItem("IPCOUNTRY")!==""){this.setState({ "fab_isHidden":false });}
    })
    .catch(err => {
      console.log(methName+"err="+err);
    });
  }
  //----------------------------------------------------------------------------------------------------
  getCurrenciesWebServices(){
    let methName = filename+"getCurrenciesWebServices ";
    if(api.print_logs){console.log(methName);}

    //-------------
    //getCurrencies---CACHED
    //-------------
    let retrieveWSData_getCurrencies = wu_CurrenciesService.wu_should_getCurrencies();
    if(retrieveWSData_getCurrencies){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CurrenciesService
      .wu_getCurrencies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
        this.serviceAvailability();
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_currencies({});
        //let parserObject_getCountries4Picker= [];
        //for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
        this.serviceAvailability();
      });
    }
    else{
      try{
        //this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCurrencies="+retrieveWSData_getCurrencies);}
        let res = JSON.parse(localStorage.getItem("currencies")); //console.log(localStorage.getItem("currencies"));
        //let parserObject_getCountries4Picker= [];
        //for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({ "parserObject_getCurrencies_ALL" : res.countries }); //YES! the subitem is countries!!!
        this.serviceAvailability();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  serviceAvailability(){
    let methName = filename+"serviceAvailability ";
    if(api.print_logs){console.log(methName);}

    //-------------------
    //serviceAvailability---CACHED
    //-------------------
    let retrieveWSData_serviceAvailability = wu_ServiceAvailabilityService.wu_should_callServiceAvailability();
    if(retrieveWSData_serviceAvailability){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_ServiceAvailabilityService
      .wu_serviceAvailability({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_serviceAvailability="+retrieveWSData_serviceAvailability);}
        if(res.wuAvailable ==="0"){this.dialog_handleOpen(res.returnText);}
        this.checkAppVersion();//this.repeatTransaction();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_serviceAvailability="+retrieveWSData_serviceAvailability);}
        this.checkAppVersion();//this.repeatTransaction();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_serviceAvailability="+retrieveWSData_serviceAvailability);}
        this.checkAppVersion();//this.repeatTransaction();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  checkAppVersion(){
    let methName = filename+"checkAppVersion ";
    if(api.print_logs){console.log(methName);}

    //---------------
    //checkAppVersion---CACHED
    //---------------
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let retrieveWSData_checkAppVersion = wu_AppVersion.wu_should_checkAppVersion();
    if(retrieveWSData_checkAppVersion){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        if(res.isMajorUpdate===true){
          this.dialog_checkAppVersion_handleOpen(res.returnText);
          return;
        }
        this.repeatTransaction();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        this.repeatTransaction();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        this.repeatTransaction();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  repeatTransaction(){
    let methName = filename+"repeatTransaction ";
    if(api.print_logs){console.log(methName);}

    //------------------
    //repeat transaction
    //------------------
    let aRow = {};
    try { aRow = JSON.parse(localStorage.getItem("parserObject_transhistorydetail_unique")); }catch(err){;}
    let transactionId = "";
    try {transactionId = aRow["trans_id"]; }catch(err){;} if(transactionId === null || (typeof transactionId === "undefined")){transactionId = "";}
    if(api.print_logs){console.log("transactionId="+transactionId);}//SOS
    if(transactionId !== ""){
        // [self buildUI_repeatTrans_country];
        // [self buildUI_repeatTrans_currency];
        // [self buildUI_repeatTrans_state];
        // [self buildUI_repeatTrans_payment_method];
        // [self buildUI_repeatTrans_transfer_method];

        let ws_country       = "";
        let ws_state         = "";
        let ws_paymentMethod = ""; //"AL"
        let ws_typeId        = 0;  //1,21,etc
        let ws_currencyIsoId = ""; //"ALL"
        let ws_totalAmount   = 0.0; //7.9
        try{ ws_country       = aRow["country"];       }catch(err){;} if(ws_country       === null || (typeof ws_country       === "undefined")){ws_country       = "";  }
        try{ ws_state         = aRow["state"];         }catch(err){;} if(ws_state         === null || (typeof ws_state         === "undefined")){ws_state         = "";  }
        try{ ws_paymentMethod = aRow["paymentMethod"]; }catch(err){;} if(ws_paymentMethod === null || (typeof ws_paymentMethod === "undefined")){ws_paymentMethod = "";  }
        try{ ws_typeId        = aRow["typeId"];        }catch(err){;} if(ws_typeId        === null || (typeof ws_typeId        === "undefined")){ws_typeId        = 0.0; }
        try{ ws_currencyIsoId = aRow["currencyIsoId"]; }catch(err){;} if(ws_currencyIsoId === null || (typeof ws_currencyIsoId === "undefined")){ws_currencyIsoId = "";  }
        try{ ws_totalAmount   = aRow["totalAmount"];   }catch(err){;} if(ws_totalAmount   === null || (typeof ws_totalAmount   === "undefined")){ws_totalAmount   = 0.0; }

        this.setState({
          picker1_selIndex                                     : wu_Utilities.findCountryIndexFromCountryId(ws_country,localStorage.getItem("lang"),"transfer"),  //Country
          picker1_textFieldLabel1_id                           : ws_country,
          picker1_textFieldLabel1_text                         : this.state.picker1_textFieldLabel1_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_country,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_country,localStorage.getItem("lang")),
          picker1_textFieldLabel1_hasError                     : false,
          picker2_selIndex_currencySend                        : 0,  //2-Send Currency
          picker2_textFieldLabel1_text                         : "Euro",
          picker2_textFieldLabel1_id                           : "EUR",
        //picker3_selIndex_currencyReceive                     : 0,  //3-Receive Currency
        //picker3_textFieldLabel1_id                           : "",
        //picker3_textFieldLabel1_text                         : "",
        //picker3_textFieldLabel1_hasError                     : false,
          picker4_selIndex_State                               : 0,  //4-State
          picker4_textFieldLabel1_text                         : "",
          picker4_textFieldLabel1_id                           : "",
          picker5_selIndex_City                                : 0,  //5-City
          picker5_textFieldLabel1_text                         : "",
          picker5_textFieldLabel1_id                           : "",

          viewState_isHidden                                   : true,
          viewCity_isHidden                                    : true,
          viewStateCity_isHidden                               : true,

          textFieldYouSend                                     : "",//ws_totalAmount.toString().replace(",", "."),

          picker6_textFieldLabel1                              : (ws_typeId===21)                ? this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1") : this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1"), //6-TranferMethod
          picker7_textFieldLabel1                              : (ws_paymentMethod==="OMT_BANK") ? this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1") : this.NSInforString("TransferOnline_viewPM_lbl_CC_lb1"), //7-PaymentMethod

          viewTM_view_CM_isHidden                              : false,
          viewTM_view_BA_isHidden                              : true,

          PM_BT_image                                          : (ws_paymentMethod==="OMT_BANK") ? WU_PAYMENT_bank_active : WU_PAYMENT_bank_inactive,
          PM_CC_image                                          : (ws_paymentMethod==="OMT_BANK") ? WU_PAYMENT_card_inactive : WU_PAYMENT_card_active,
          TM_CM_image                                          : (ws_typeId===21) ? WU_PAYMENT_cash_inactive : WU_PAYMENT_cash_active,
          TM_BA_image                                          : (ws_typeId===21) ? WU_PAYMENT_bank_active   : WU_PAYMENT_bank_inactive,

          "TransferOnline1_PaymentMethod"                      : (ws_paymentMethod==="OMT_BANK") ? api.TransferOnline1_PaymentMethod_BankTransfer : api.TransferOnline1_PaymentMethod_CreditCard,
          "TransferOnline1_TransferMethod"                     : (ws_typeId===21)                ? api.TransferOnline1_TransferMethod_Bank : api.TransferOnline1_TransferMethod_Cash,
        });
        if(ws_paymentMethod==="OMT_BANK"){ localStorage.setItem("TransferOnline1_PaymentMethod",api.TransferOnline1_PaymentMethod_BankTransfer); }
        else                             { localStorage.setItem("TransferOnline1_PaymentMethod",api.TransferOnline1_PaymentMethod_CreditCard);   }
        if(ws_typeId===21){ localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Bank); }
        else              { localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Cash); }

        this.updateUI_select_COUNTRY_reload_CURRENCY_select_CURRENCY(ws_country,ws_currencyIsoId);
        this.updateUI_reload_STATE_select_STATE(ws_country,ws_state);
    }
    this.cookiesFromSite();
  }
  //----------------------------------------------------------------------------------------------------
  cookiesFromSite() {
    let methName = filename+"cookiesFromSite ";
    if(api.print_logs){console.log(methName);}

    //-----------------
    //Cookies from Site
    //-----------------
    let cookie_country = Cookies.get('country'); if( cookie_country===null || (typeof cookie_country === "undefined") ){cookie_country="";}
    let cookie_amount  = Cookies.get('amount');  if( cookie_amount ===null || (typeof cookie_amount  === "undefined") ){cookie_amount ="";}
    if(api.print_logs){console.log(methName+"cookie_country="+cookie_country+",cookie_amount="+cookie_amount);}
    //cookie_country = "AUSTRALIA";
    //cookie_amount = "100";
    if(cookie_country!=="" && cookie_amount!==""){
      let ws_country = wu_Utilities.findCountryIdFromCountryName(cookie_country);
      this.setState({
        picker1_selIndex                                     : wu_Utilities.findCountryIndexFromCountryId(ws_country,localStorage.getItem("lang"),"transfer"),  //Country
        picker1_textFieldLabel1_id                           : ws_country,
        picker1_textFieldLabel1_text                         : this.state.picker1_textFieldLabel1_AUTOCOMPLETE_MODE==="text" ? wu_Utilities.findCountryNameFromCountryId(ws_country,localStorage.getItem("lang")) : wu_Utilities.findCountryObjFromCountryId(ws_country,localStorage.getItem("lang")),
        picker1_textFieldLabel1_hasError                     : false,

        textFieldYouSend                                     : cookie_amount,
      });

      Cookies.set('country', '');
      Cookies.set('amount',  '');

      this.updateUI_select_COUNTRY_reload_CURRENCY(ws_country);
      if(ws_country==="US" || ws_country==="MX"){
        this.makeHTTPConn_select_COUNTRY_reload_STATE(ws_country);
      }
      else{
        this.setState({ "viewStateCity_isHidden":true, "viewState_isHidden":true, "viewCity_isHidden":true });
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    // setTimeout(function() {
    //   try{
    //     document.getElementById("CybotCookiebotDialogBodyLevelButtonsSelectPane").style.visibility = "hidden";
    //   }catch(err){
    //     console.log(methName+'err='+err);
    //   }
    // }.bind(this), 1000);

    //----------------------
    //Criteo Event Recording
    //----------------------
    let shouldUseCriteo = api.shouldUseCriteo;
    if(shouldUseCriteo===true && api.webappENV==="PROD"){
      try {
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
         { event: "setAccount", account: api.criteo_account }, // You should never update this line
         { event: "setEmail", email: "" },                  // Can be an empty string
         { event: "setSiteType", type: deviceType},
         { event: "trackTransaction", id: Math.floor(Math.random()*99999999999)+1, item: [{id:"1", price:1, quantity:1}] }
        );
      }catch(err0){console.log(methName+"err0="+err0);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    let btn_next_state_TMP = (this.state.btn_next_state==="Υπολογισμός" || this.state.btn_next_state==="Calculate") ? this.NSInforString("TransferOnline_btn_calc") : this.NSInforString("TransferOnline_btn_next");
    //-------
    //Country
    //-------
    let defaultPropsCountry  = {};
    let filterOptionsCountry = {};
    if(this.state.picker1_textFieldLabel1_AUTOCOMPLETE_MODE === "text"){
      defaultPropsCountry  = { options:this.state.parserObject_getCountries4Picker, getOptionLabel:option => option,};
      filterOptionsCountry = createFilterOptions({matchFrom: this.state.picker1_textFieldLabel1_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsCountry = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_en ? option.descr_en : "", }; }
      else                                   { defaultPropsCountry = { options:this.state.parserObject_getCountries, getOptionLabel:option => option.descr_el ? option.descr_el : "", }; }
      filterOptionsCountry = createFilterOptions({matchFrom: this.state.picker1_textFieldLabel1_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr_el + option.descr_en + option.keywords,});
    }

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          {/* [FAB] */}
          {this.state.fab_isHidden === true ? ( "" ) : (
            <Fab color="primary" aria-label="add" onClick={this.fab_Click2CallAction} className={classes.fab}>
              <CallIcon />
            </Fab>
          )}
          <GridItem xs={12} sm={6} md={6}>
              {/* ------------------------- */}
              {/* ----------[STEPS3]------- */}
              {/* ------------------------- */}
              {this.state.viewSteps3_view_isHidden === true ? ( "" ) : (
                <div style={{ marginTop: 20 }}>
                  <GridContainer justify="center">
                    <GridItem xs={3} sm={3} md={2}>
                      <div className={classes.viewSteps3Image}><img src={WU_STEPS_estimate_active} alt=""/></div>
                      <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl1")}</div>
                    </GridItem>
                    <GridItem xs={1} sm={1} md={3}>
                      <div className={classes.viewSteps3Label}>&nbsp;</div>
                      <div className={classes.viewSteps3Image}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                    </GridItem>
                    <GridItem xs={3} sm={3} md={2}>
                      <div className={classes.viewSteps3Image}><img src={WU_STEPS_recipient_inactive} alt=""/></div>
                      <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl2")}</div>
                    </GridItem>
                    <GridItem xs={1} sm={1} md={3}>
                      <div className={classes.viewSteps3Label}>&nbsp;</div>
                      <div className={classes.viewSteps3Image}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                    </GridItem>
                    <GridItem xs={3} sm={3} md={2}>
                      <div className={classes.viewSteps3Image}><img src={WU_STEPS_review_inactive} alt=""/></div>
                      <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl3")}</div>
                    </GridItem>
                  </GridContainer>
                </div>
              )}
              {/* ------------------------- */}
              {/* ----------[STEPS4]------- */}
              {/* ------------------------- */}
              {this.state.viewSteps4_view_isHidden === true ? ( "" ) : (
                <div style={{ marginTop: 20 }}>
                  <GridContainer justify="center">
                    <GridItem xs={2} sm={2} md={2}>
                      <div className={classes.viewSteps4Image}><img src={WU_STEPS_estimate_active} alt=""/></div>
                      <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl1")}</div>
                    </GridItem>
                    <GridItem xs={1} sm={1} md={1}>
                      <div className={classes.viewSteps4Label}>&nbsp;</div>
                      <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <div className={classes.viewSteps4Image}><img src={WU_STEPS_sender_inactive} alt=""/></div>
                      <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl2")}</div>
                    </GridItem>
                    <GridItem xs={1} sm={1} md={1}>
                      <div className={classes.viewSteps4Label}>&nbsp;</div>
                      <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <div className={classes.viewSteps4Image}><img src={WU_STEPS_recipient_inactive} alt=""/></div>
                      <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl3")}</div>
                    </GridItem>
                    <GridItem xs={1} sm={1} md={1}>
                      <div className={classes.viewSteps4Label}>&nbsp;</div>
                      <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2}>
                      <div className={classes.viewSteps4Image}><img src={WU_STEPS_review_inactive} alt=""/></div>
                      <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl4")}</div>
                    </GridItem>
                  </GridContainer>
                </div>
              )}
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.TransferOnline_lbl_header_paymentDetails}>{this.NSInforString("TransferOnline_lbl_header_paymentDetails")}</div>
                </GridItem>
              </GridContainer>
              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete={this.autoCompleteText_Textfields()}
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>
              </GridContainer>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.picker1_textFieldLabel1_AUTOCOMPLETE_MODE === "text" ? (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                    <Autocomplete
                      {...defaultPropsCountry}
                      id="picker1_textFieldLabel1"
                      value={this.state.picker1_textFieldLabel1_text}
                      onChange={(event,value) => this.handleCustomDropDownClick_country(event,value)}
                      disableClearable
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                      renderInput={params =><TextField {...params} error={this.state.picker1_textFieldLabel1_hasError} label={this.NSInforString("TransferOnline_pic1")} name={"off"+Math.random()} />}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>
              ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                    <Autocomplete
                      filterOptions={filterOptionsCountry}
                      {...defaultPropsCountry}
                      id="picker1_textFieldLabel1"
                      value={this.state.picker1_textFieldLabel1_text}
                      onChange={(event,value) => this.handleCustomDropDownClick_country(event,value)}
                      disableClearable
                      renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(option.descr_en).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr_en}</Typography></React.Fragment>);}}
                      renderInput={params =><TextField {...params} error={this.state.picker1_textFieldLabel1_hasError} label={this.NSInforString("TransferOnline_pic1")} name={"off"+Math.random()} />}
                    />
                  </FormControl>
                </GridItem>
              </GridContainer>
              ) }
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {this.state.viewStateCity_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={6} sm={6} md={6}>
                    <FormControl fullWidth className={classes.picker1_textFieldLabel4}>
                      <InputLabel id="picker1_textFieldLabel4_InputLabel">{this.NSInforString("TransferOnline_pic4")}</InputLabel>
                      <Select
                        displayEmpty
                        id="picker1_textFieldLabel4"
                        value={this.state.picker4_textFieldLabel1_text}
                        onChange={event => this.handleCustomDropDownClick_state(event)}
                      >
                        {this.state.parserObject_getStates4Picker.map(function (akey) {
                          return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                  {this.state.viewCity_isHidden === true ?
                    <GridItem xs={6} sm={6} md={6}>
                    </GridItem>
                    :
                    (
                    <GridItem xs={6} sm={6} md={6}>
                      <FormControl fullWidth className={classes.picker1_textFieldLabel5}>
                        <InputLabel id="picker1_textFieldLabel5_InputLabel">{this.NSInforString("TransferOnline_pic5")}</InputLabel>
                        <Select
                          displayEmpty
                          id="picker1_textFieldLabel5"
                          value={this.state.picker5_textFieldLabel1_text}
                          onChange={event => this.handleCustomDropDownClick_city(event)}
                        >
                          {this.state.parserObject_getCities4Picker.map(function (akey) {
                            return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                          })}
                        </Select>
                      </FormControl>
                    </GridItem>
                  )}
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker3_textFieldLabel1_hasError} className={classes.picker3_textFieldLabel1}>
                    <InputLabel id="picker3_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline_pic3")}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker3_textFieldLabel1"
                      value={this.state.picker3_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_currency(event)}
                    >
                      {this.state.parserObject_getCurrencies4Picker.map(function (akey) {
                        return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridContainer justify="center">
                <GridItem xs={5} sm={5} md={5} className={classes.GridItemLocalR}>
                  <TextField
                    fullWidth
                    className={classes.textFieldYouSend}
                    id="textFieldYouSend"
                    label={this.NSInforString("TransferOnline_lbl_YouSend")}
                    value={this.state.textFieldYouSend}
                    error   ={this.state.textFieldYouSend_hasError}
                    disabled={this.state.textFieldYouSend_disabled}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "textFieldYouSend"),
                      type: "text",
                      endAdornment: <InputAdornment position="end">EUR</InputAdornment>,
                    }}
                  />
                </GridItem>
                <GridItem xs={2} sm={2} md={2} className={classes.GridItemLocal}>
                  <Button onClick={this.btn_arrows_act}>
                    <div className={classes.btn_arrows}><img src={WU_FORM_compare} alt=""/></div>
                  </Button>
                </GridItem>
                <GridItem xs={5} sm={5} md={5} className={classes.GridItemLocalL}>
                  <TextField
                    fullWidth
                    className={classes.textFieldReceiverGets}
                    id="textFieldReceiverGets"
                    label={this.NSInforString("TransferOnline_lbl_ReceiverGets")}
                    value={this.state.textFieldReceiverGets}
                    error={this.state.textFieldReceiverGets_hasError}
                    disabled={this.state.textFieldReceiverGets_disabled}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "textFieldReceiverGets"),
                      type: "text",
                      endAdornment: <InputAdornment position="end">{this.state.picker3_textFieldLabel1_id}</InputAdornment>,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {/* -------------------------------- */}
              {/* ----------[PaymentMethod]------- */}
              {/* -------------------------------- */}
              <div style={{ marginTop:20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline_lbl_header_paymentMethod}>{this.NSInforString("TransferOnline_lbl_header_paymentMethod")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              <GridContainer justify="center">
                <GridItem xs={4} sm={4} md={3} style={{textAlign:"center"}}>
                  <Button onClick={this.PM_BT_act}>
                  <div className={classes.PMTMImage}><img src={this.state.PM_BT_image} alt=""/></div>
                  </Button>
                  <div className={classes.PMTMLabel}>{this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1")}</div>
                </GridItem>
                <GridItem xs={4} sm={4} md={3} style={{textAlign:"center"}}>
                  <Button onClick={this.PM_CC_act}>
                  <div className={classes.PMTMImage}><img src={this.state.PM_CC_image} alt=""/></div>
                  </Button>
                  <div className={classes.PMTMLabel}>{this.NSInforString("TransferOnline_viewPM_lbl_CC_lb1")}</div>
                </GridItem>
                <GridItem xs={4} sm={4} md={6}>
                </GridItem>
              </GridContainer>
              {/* <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline1_lbl_card1}>{this.NSInforString("TransferOnline1_lbl_card1")}<img height="28" src={WU_Card_logos_visa} alt=""/><img height="30" src={WU_Card_logos_mastercard} alt=""/></div>
                </GridItem>
              </GridContainer> */}
              {/* -------------------------------- */}
              {/* ----------[TransferMethod]------ */}
              {/* -------------------------------- */}
              <div style={{ marginTop:20 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline_lbl_header_transferMethod}>{this.NSInforString("TransferOnline_lbl_header_transferMethod")}</div>
                  </GridItem>
                </GridContainer>
              </div>
              <GridContainer justify="center">
                {this.state.viewTM_view_CM_isHidden === false && this.state.viewTM_view_BA_isHidden === false ? (
                  <React.Fragment>
                    <GridItem xs={4} sm={4} md={3} style={{textAlign:"center"}}>
                      <Button onClick={this.TM_CM_act}>
                      <div className={classes.PMTMImage}><img src={this.state.TM_CM_image} alt=""/></div>
                      </Button>
                      <div className={classes.PMTMLabel}>{this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1")}</div>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={3} style={{textAlign:"center"}}>
                      <Button onClick={this.TM_BA_act}>
                      <div className={classes.PMTMImage}><img src={this.state.TM_BA_image} alt=""/></div>
                      </Button>
                      <div className={classes.PMTMLabel}>{this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1")}</div>
                    </GridItem>
                    <GridItem xs={4} sm={4} md={6}>
                    </GridItem>
                  </React.Fragment>
                ) : (
                  ""
                )}
                {this.state.viewTM_view_CM_isHidden === false && this.state.viewTM_view_BA_isHidden === true ? (
                  <React.Fragment>
                    <GridItem xs={4} sm={4} md={3} style={{textAlign:"center"}}>
                      <Button onClick={this.TM_CM_act}>
                      <div className={classes.PMTMImage}><img src={this.state.TM_CM_image} alt=""/></div>
                      </Button>
                      <div className={classes.PMTMLabel}>{this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1")}</div>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={9}>
                    </GridItem>
                  </React.Fragment>
                ) : (
                  ""
                )}
                {this.state.viewTM_view_CM_isHidden === true && this.state.viewTM_view_BA_isHidden === false ? (
                  <React.Fragment>
                    <GridItem xs={4} sm={4} md={3} style={{textAlign:"center"}}>
                      <Button onClick={this.TM_BA_act}>
                      <div className={classes.PMTMImage}><img src={this.state.TM_BA_image} alt=""/></div>
                      </Button>
                      <div className={classes.PMTMLabel}>{this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1")}</div>
                    </GridItem>
                    <GridItem xs={8} sm={8} md={9}>
                    </GridItem>
                  </React.Fragment>
                ) : (
                  ""
                )}
                {this.state.viewTM_view_CM_isHidden === true && this.state.viewTM_view_BA_isHidden === true ? (
                  <React.Fragment>
                    <GridItem xs={6} sm={6} md={6}>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6}>
                    </GridItem>
                  </React.Fragment>
                ) : (
                  ""
                )}
                <GridItem xs={6} sm={6} md={6}>
                </GridItem>
              </GridContainer>
              {/* -------------------------------- */}
              {/* ----------[Promo]--------------- */}
              {/* -------------------------------- */}
              <div style={{ marginTop:20 }}>
                <Button onClick={this.WU_FORM_promo_openclose_act}>
                  <div className={classes.WU_FORM_promo_openclose}><img src={this.state.WU_FORM_promo_openclose_img} alt=""/></div>
                  <div className={classes.TransferOnline_viewPromoInfo_lbl_info}>{this.NSInforString("TransferOnline_viewPromoInfo_lbl_info")}</div>
                </Button>
                {this.state.promo_isHidden===true ? ("") : (
                  <TextField
                    fullWidth
                    error   ={this.state.textField100_hasError}
                    disabled={this.state.textField100_disabled}
                    className={classes.textField100}
                    id="textField100"
                    label={this.NSInforString("TransferOnline_plh100")}
                    value={this.state.textField100}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "textField100"),
                      type: "text",
                    }}
                  />
                )}
              </div>
              {/* ------------------------- */}
              {/* ----------[RESULTS]------ */}
              {/* ------------------------- */}
              {this.state.viewRN_isHidden === true ? ( "" ) : (
                <div style={{ marginTop:15, marginBottom:15, "backgroundColor":"#EAEBED", padding:"0.8rem" }}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer justify="center" style={{ marginTop:0}}>
                        <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline_viewE_lbl_key1")}</div></GridItem>
                        <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.viewExp_lbl_val1}</div></GridItem>
                      </GridContainer>
                      <GridContainer justify="center" style={{ marginTop:10}}>
                        <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline_viewE_lbl_key2")}</div></GridItem>
                        <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.viewExp_lbl_val2}</div></GridItem>
                      </GridContainer>

                      {this.state.viewExp_lbl_val3_show === false ? ( "" ) : (
                        <GridContainer justify="center" style={{ marginTop:10}}>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline_viewE_lbl_key3")}</div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.viewExp_lbl_val3}</div></GridItem>
                        </GridContainer>
                      )}

                      <GridContainer justify="center" style={{ marginTop:10}}>
                        <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline_viewE_lbl_key4")}</div></GridItem>
                        <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.viewExp_lbl_val4}</div></GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </div>
              )}
              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    {/*<ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.btn_next_act } /> */}
                    <CustomButton
                      disabled={this.btn_next_act_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_next_act}
                      type="submit">
                      {btn_next_state_TMP}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
              {/* -------------------------------------------------- */}
              {/* ----------[scrollToBottom]------------------------ */}
              {/* -------------------------------------------------- */}
              {api.buildDateEnabled !== true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline_lbl_buildDateStr}>{api.buildDateStr}</div>
                  </GridItem>
                </GridContainer>
              )}
              <div id="scrollHere2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP][FAB]--- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog100_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog100_handleClose}
            aria-labelledby="alert-dialog100-slide-title"
            aria-describedby="alert-dialog100-slide-description"
          >
            <DialogTitle id="alert-dialog100-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="en" ? (
              <DialogContent>Need assistance?<br/>We are at your disposal!<br/>Call us at<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>or<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(toll free from a landline)<br/><br/>Call Center operating hours:<br/>Monday to Sunday 08:00 με 21:00</DialogContent>
            ) : (
              <DialogContent>Χρειάζεσαι βοήθεια;<br/>Είμαστε στη διάθεσή σου!<br/>Κάλεσε μας στο<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>ή στο<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(χωρίς χρέωση από σταθερό)<br/><br/>Ωράριο τηλεφωνικής εξυπηρέτησης:<br/>Δευτέρα με Κυριακή 08:00 με 21:00</DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog100_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP checkAppVersion]------ */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_checkAppVersion_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_checkAppVersion_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_checkAppVersion_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_checkAppVersion} color="default" onClick={this.dialog_checkAppVersion_btn_ok}>{this.NSInforString("dialog_checkAppVersion_btn_ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_COUNTRY_reload_STATE(ctry_wu_id){
    let methName = filename+"makeHTTPConn_select_COUNTRY_reload_STATE ";

    //------------
    //wu_getStates
    //------------
    wu_CountriesStatesCitiesService
    .wu_getStates({country:ctry_wu_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getStates4Picker= [];
      for(var i=0; i<res.states.length; ++i){ parserObject_getStates4Picker.push(res.states[i]["state_name"]); }
      this.setState({ "parserObject_getStates"        : res.states });
      this.setState({ "parserObject_getStates4Picker" : parserObject_getStates4Picker });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true });}
    this.setState({ "viewStateCity_isHidden":false });

    //repeat transaction
    //if(mainDelegate.parserObject_transhistorydetail_unique!=null){
    //    [self buildUI_repeatTrans_state_selectItemOnPicker];
    //}

    return;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_select_STATE_reload_CITY(ctry_wu_id,state_id){
    let methName = filename+"makeHTTPConn_select_STATE_reload_CITY ";

    //------------
    //wu_getCities
    //------------
    wu_CountriesStatesCitiesService
    .wu_getCities({country:ctry_wu_id,state:state_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getCities4Picker= [];
      for(var i=0; i<res.cities.length; ++i){ parserObject_getCities4Picker.push(res.cities[i]["descr_el"]); }
      this.setState({ "parserObject_getCities"        : res.cities });
      this.setState({ "parserObject_getCities4Picker" : parserObject_getCities4Picker });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true  });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":false });}
    this.setState({ "viewStateCity_isHidden":false });

    return;
  }
  //----------------------------------------------------------------------------------------------------
  updateUI_select_COUNTRY_reload_CURRENCY(ctry_wu_id){
    let methName = filename+"updateUI_select_COUNTRY_reload_CURRENCY ";
    if(api.print_logs){console.log(methName+'ctry_wu_id='+ctry_wu_id);}

    let currencyItems = this.state.parserObject_getCurrencies_ALL;
    if(currencyItems.length===0){
      try{
        let res = JSON.parse(localStorage.getItem("currencies")); //console.log(localStorage.getItem("currencies"));
        currencyItems = res.countries; //YES! the subitem is countries!!!
      }catch(err){
        console.log(methName+'err='+err);
      }
    }

    for (let i=0; i<currencyItems.length && ctry_wu_id !==""; ++i) {
        let item = currencyItems[i];
        if(ctry_wu_id === item.ctry_wu_id){
            let countryCurrencies = item["currencies"];
            if(countryCurrencies.length===1){
                localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"       : countryCurrencies,
                  "parserObject_getCurrencies4Picker": parserObject_getCurrencies4Picker,
                  "picker3_selIndex_currencyReceive" : 0,
                  "picker3_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            else if(countryCurrencies.length>1){
                localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                //5Α16
                //countryCurrencies = [{curr_iso_id:"",curr_descr:this.NSInforString("TransferOnline_pic3")}].concat(countryCurrencies);

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"       : countryCurrencies,
                  "parserObject_getCurrencies4Picker": parserObject_getCurrencies4Picker,
                  "picker3_selIndex_currencyReceive" : 0,
                  "picker3_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            break;
        }
    }
  }
  //----------------------------------------------------------------------------------------------------
  updateUI_select_COUNTRY_reload_CURRENCY_select_CURRENCY(ctry_wu_id,ws_currencyIsoId){
    let methName = filename+"updateUI_select_COUNTRY_reload_CURRENCY_select_CURRENCY ";

    let res = JSON.parse(localStorage.getItem("currencies"));
    let parserObject_getCurrencies_ALL = res.countries;
    //if(api.print_logs){console.log(methName+'ctry_wu_id='+ctry_wu_id+",ws_currencyIsoId="+ws_currencyIsoId+",parserObject_getCurrencies_ALL.length="+parserObject_getCurrencies_ALL.length);}

    for (let i=0; i<parserObject_getCurrencies_ALL.length && ctry_wu_id !==""; ++i) {
        let item = parserObject_getCurrencies_ALL[i];
        if(api.print_logs){console.log(methName+'ctry_wu_id='+ctry_wu_id+",item.ctry_wu_id="+item.ctry_wu_id);}
        if(ctry_wu_id === item.ctry_wu_id){
            let countryCurrencies = item["currencies"];
            if(countryCurrencies.length===1){
                localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"       : countryCurrencies,
                  "parserObject_getCurrencies4Picker": parserObject_getCurrencies4Picker,
                  "picker3_selIndex_currencyReceive" : 0,
                  "picker3_textFieldLabel1_id"       : countryCurrencies[0]["curr_iso_id"],
                  "picker3_textFieldLabel1_text"     : countryCurrencies[0]["curr_descr"],
                  "picker3_textFieldLabel1_hasError" : false,
                });
                if(api.print_logs){console.log('[1] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            else if(countryCurrencies.length>1){
                localStorage.setItem("parserObject_getCurrencies4CountryRec_isD2B",    item[api.hasD2BfName]===true?"true":"false");
                localStorage.setItem("parserObject_getCurrencies4CountryRec_localCur", item["localCur"]);
                this.setState({ "viewTM_view_BA_isHidden" : (item[api.hasD2BfName]===true) ? false : true });

                //5Α16
                //countryCurrencies = [{curr_iso_id:"",curr_descr:this.NSInforString("TransferOnline_pic3")}].concat(countryCurrencies);

                let currencyIndex = 0;
                for(let ii=0; ii<countryCurrencies.length; ++ii){
                  if(countryCurrencies[ii]["curr_iso_id"]===ws_currencyIsoId){ currencyIndex=ii; break; }
                }

                let parserObject_getCurrencies4Picker= [];
                for(let ii=0; ii<countryCurrencies.length; ++ii){ parserObject_getCurrencies4Picker.push(countryCurrencies[ii]["curr_descr"]); }
                this.setState({
                  "parserObject_getCurrencies"       : countryCurrencies,
                  "parserObject_getCurrencies4Picker": parserObject_getCurrencies4Picker,
                  "picker3_selIndex_currencyReceive" : currencyIndex,
                  "picker3_textFieldLabel1_id"       : countryCurrencies[currencyIndex]["curr_iso_id"],
                  "picker3_textFieldLabel1_text"     : countryCurrencies[currencyIndex]["curr_descr"],
                  "picker3_textFieldLabel1_hasError" : false,
                 });
                if(api.print_logs){console.log('[2] ctry_wu_id='+ctry_wu_id+',parserObject_getCurrencies4Picker='+parserObject_getCurrencies4Picker);}
            }
            break;
        }
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  updateUI_reload_STATE_select_STATE(ctry_wu_id,ws_state_id){
    let methName = filename+"updateUI_reload_STATE_select_STATE ";

    //console.log('ctry_wu_id='+ctry_wu_id);
    if(ctry_wu_id !== "US" && ctry_wu_id !== "MX"){return;}

    //------------
    //wu_getStates
    //------------
    wu_CountriesStatesCitiesService
    .wu_getStates({country:ctry_wu_id})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      var parserObject_getStates4Picker= [];
      for(var i=0; i<res.states.length; ++i){ parserObject_getStates4Picker.push(res.states[i]["state_name"]); }

      let stateIndex = 0;
      for(let i=0; i<res.states.length; ++i){
        if(res.states[i]["state_code"]===ws_state_id){
          stateIndex = i;
          console.log("1 ctry_wu_id="+ctry_wu_id+",ws_state_id="+ws_state_id+",stateIndex="+stateIndex);
          break;
        }
      }
      console.log("2 ctry_wu_id="+ctry_wu_id+",ws_state_id="+ws_state_id+",stateIndex="+stateIndex);
      this.setState({
        "parserObject_getStates"        : res.states,
        "parserObject_getStates4Picker" : parserObject_getStates4Picker,
        "picker4_selIndex_State"        : stateIndex,
        "picker4_textFieldLabel1_id"    : res.states[stateIndex]["state_code"],
        "picker4_textFieldLabel1_text"  : res.states[stateIndex]["state_name"],
      });
    })
    .catch(err => {
      console.log(methName+"err="+JSON.stringify(err));
    });

    if(ctry_wu_id === "US"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true });}//before select state do not show city
    if(ctry_wu_id === "MX"){this.setState({ "viewState_isHidden":false }); this.setState({ "viewCity_isHidden":true });}
    this.setState({ "viewStateCity_isHidden":false });

    //repeat transaction
    //if(mainDelegate.parserObject_transhistorydetail_unique!=null){
    //    [self buildUI_repeatTrans_state_selectItemOnPicker];
    //}

    return;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_country(event,value) {
    let methName = filename+"handleCustomDropDownClick_country ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.picker1_textFieldLabel1_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr_en;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "picker1_textFieldLabel1_text"     : eventTMP1,
      "picker1_textFieldLabel1_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getCountries4Picker.length; ++i){
      if(this.state.parserObject_getCountries4Picker[i]===eventTMP2){
        this.setState({
          "picker1_selIndex"           : i,
          "picker1_textFieldLabel1_id" : this.state.parserObject_getCountries[i].ctry_wu_id,

          //reset
          "viewRN_isHidden"                : true,
          "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
          "textFieldYouSend"               : "",
          "textFieldYouSend_hasError"      : false,
          "textFieldYouSend_disabled"      : false,
          "textFieldReceiverGets"          : "",
          "textFieldReceiverGets_hasError" : false,
          "textFieldReceiverGets_disabled" : true,
          PM_BT_image                      : WU_PAYMENT_bank_active,
          PM_CC_image                      : WU_PAYMENT_card_inactive,
        //TM_CM_image                      : WU_PAYMENT_cash_active, //WU_PAYMENT_cash_active,
          TM_BA_image                      : WU_PAYMENT_bank_inactive,

          "viewTM_view_CM_isHidden"        : this.find_viewTM_view_CM_isHidden(this.state.parserObject_getCountries[i].ctry_wu_id),//DownClick_country
          TM_CM_image                      : this.find_TM_CM_image(this.state.parserObject_getCountries[i].ctry_wu_id),
        });
        localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_send);
        localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
        localStorage.setItem("TransferOnline1_TransferMethod",this.find_TransferOnline1_TransferMethod(this.state.picker1_textFieldLabel1_id));
        localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);

        let ctry_wu_id_TMP = this.state.parserObject_getCountries[i].ctry_wu_id;
        this.updateUI_select_COUNTRY_reload_CURRENCY(ctry_wu_id_TMP);
        if(ctry_wu_id_TMP==="US" || ctry_wu_id_TMP==="MX"){
          this.makeHTTPConn_select_COUNTRY_reload_STATE(ctry_wu_id_TMP);
        }
        else{
          this.setState({ "viewStateCity_isHidden":true, "viewState_isHidden":true, "viewCity_isHidden":true });
        }
        break;
      }
    }
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  find_viewTM_view_CM_isHidden(ctry_wu_id){
    //nailed for testing:START---inactive
    //return true;
    //nailed for testing:END
    for(let i=0; i<this.state.parserObject_getCountries.length; ++i){
      if(this.state.parserObject_getCountries[i].ctry_wu_id === ctry_wu_id){
        if(this.state.parserObject_getCountries[i].isDigitalOut!==true){
          return true;
        }
      }
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  find_TM_CM_image(ctry_wu_id){
    //nailed for testing:START---inactive
    //return WU_PAYMENT_bank_inactive;
    //nailed for testing:END
    for(let i=0; i<this.state.parserObject_getCountries.length; ++i){
      if(this.state.parserObject_getCountries[i].ctry_wu_id === ctry_wu_id){
        if(this.state.parserObject_getCountries[i].isDigitalOut!==true){
          return WU_PAYMENT_bank_inactive;
        }
      }
    }
    return WU_PAYMENT_cash_active;
  }
  //----------------------------------------------------------------------------------------------------
  find_TransferOnline1_TransferMethod(ctry_wu_id){
    //nailed for testing:START---inactive
    //return api.TransferOnline1_TransferMethod_None;
    //nailed for testing:END
    for(let i=0; i<this.state.parserObject_getCountries.length; ++i){
      if(this.state.parserObject_getCountries[i].ctry_wu_id === ctry_wu_id){
        if(this.state.parserObject_getCountries[i].isDigitalOut!==true){
          return api.TransferOnline1_TransferMethod_None;
        }
      }
    }
    return api.TransferOnline1_TransferMethod_Cash;
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_state(event) {
    let methName = filename+"handleCustomDropDownClick_state ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "picker4_textFieldLabel1_text":eventTMP });
    for(let i=0; i<this.state.parserObject_getStates4Picker.length; ++i){
      if(this.state.parserObject_getStates4Picker[i]===eventTMP){
        this.setState({
          "picker4_selIndex_State"     : i,
          "picker4_textFieldLabel1_id" : this.state.parserObject_getStates[i].state_name,

          //reset
          "viewRN_isHidden"                : true,
          "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
          "textFieldYouSend"               : "",
          "textFieldYouSend_hasError"      : false,
          "textFieldYouSend_disabled"      : false,
          "textFieldReceiverGets"          : "",
          "textFieldReceiverGets_hasError" : false,
          "textFieldReceiverGets_disabled" : true,
          PM_BT_image                      : WU_PAYMENT_bank_active,
          PM_CC_image                      : WU_PAYMENT_card_inactive,
        //TM_CM_image                      : WU_PAYMENT_cash_active,
          TM_BA_image                      : WU_PAYMENT_bank_inactive,

          "viewTM_view_CM_isHidden"        : this.find_viewTM_view_CM_isHidden(this.state.picker1_textFieldLabel1_id), //DownClick_state
          TM_CM_image                      : this.find_TM_CM_image(this.state.picker1_textFieldLabel1_id),
        });
        localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_send);
        localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
        localStorage.setItem("TransferOnline1_TransferMethod",this.find_TransferOnline1_TransferMethod(this.state.picker1_textFieldLabel1_id));
        localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);

        let ctry_wu_id = this.state.picker1_textFieldLabel1_id;
        let state_id   = this.state.parserObject_getStates[i].state_id;
        this.makeHTTPConn_select_STATE_reload_CITY(ctry_wu_id,state_id);
        break;
      }
    }
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_city(event) {
    let methName = filename+"handleCustomDropDownClick_city ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({ "picker5_textFieldLabel1_text":eventTMP });
    for(let i=0; i<this.state.parserObject_getCities4Picker.length; ++i){
      if(this.state.parserObject_getCities4Picker[i]===eventTMP){
        this.setState({
          "picker5_selIndex_City"      : i,
          "picker5_textFieldLabel1_id" : this.state.parserObject_getCities[i].ctry_wu_id,

          //reset
          "viewRN_isHidden"                : true,
          "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
          "textFieldYouSend"               : "",
          "textFieldYouSend_hasError"      : false,
          "textFieldYouSend_disabled"      : false,
          "textFieldReceiverGets"          : "",
          "textFieldReceiverGets_hasError" : false,
          "textFieldReceiverGets_disabled" : true,
          PM_BT_image                      : WU_PAYMENT_bank_active,
          PM_CC_image                      : WU_PAYMENT_card_inactive,
        //TM_CM_image                      : WU_PAYMENT_cash_active,
          TM_BA_image                      : WU_PAYMENT_bank_inactive,

          "viewTM_view_CM_isHidden"        : this.find_viewTM_view_CM_isHidden(this.state.picker1_textFieldLabel1_id), //DownClick_city
          TM_CM_image                      : this.find_TM_CM_image(this.state.picker1_textFieldLabel1_id),
        });
        localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_send);
        localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
        localStorage.setItem("TransferOnline1_TransferMethod",this.find_TransferOnline1_TransferMethod(this.state.picker1_textFieldLabel1_id));
        localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);
        break;
      }
    }
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_currency(event) {
    let methName = filename+"handleCustomDropDownClick_currency ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker3_textFieldLabel1_text"     : eventTMP,
      "picker3_textFieldLabel1_hasError" : false,
    });
    let view_CM_isHidden = true;
    let view_BA_isHidden = true;
    if("true"===localStorage.getItem("parserObject_getCurrencies4CountryRec_isD2B")){ this.setState({ "viewTM_view_BA_isHidden" : false }); view_BA_isHidden = true; }
    else                                                                            { this.setState({ "viewTM_view_BA_isHidden" : true });  view_BA_isHidden = true; }
    for(let i=0; i<this.state.parserObject_getCurrencies4Picker.length; ++i){
      if(this.state.parserObject_getCurrencies4Picker[i]===eventTMP){
        //console.log(methName+eventTMP);
        //console.log(methName+"curr_iso_id = "+this.state.parserObject_getCurrencies[i].curr_iso_id);
        //console.log(methName+"localCur    = "+localStorage.getItem("parserObject_getCurrencies4CountryRec_localCur"));

        //2022-11-22
        if("true"===localStorage.getItem("parserObject_getCurrencies4CountryRec_isD2B")){
          if(this.state.parserObject_getCurrencies[i].curr_iso_id===localStorage.getItem("parserObject_getCurrencies4CountryRec_localCur")){
           this.setState({ "viewTM_view_BA_isHidden" : false }); view_BA_isHidden = false;
          }
          else{
           this.setState({ "viewTM_view_BA_isHidden" : true });  view_BA_isHidden = true;
          }
        }
        view_CM_isHidden = this.find_viewTM_view_CM_isHidden(this.state.picker1_textFieldLabel1_id);

        if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
          this.setState({
            "picker3_selIndex_currencyReceive" :  i,
            "picker3_textFieldLabel1_id"       :  this.state.parserObject_getCurrencies[i].curr_iso_id,

            //reset
            "viewRN_isHidden"                : true,
            "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
          //"textFieldYouSend"               : "",
          //"textFieldYouSend_hasError"      : false,
          //"textFieldYouSend_disabled"      : false,
            "textFieldReceiverGets"          : "",
            "textFieldReceiverGets_hasError" : false,
            "textFieldReceiverGets_disabled" : true,
            PM_BT_image                      : WU_PAYMENT_bank_active,
            PM_CC_image                      : WU_PAYMENT_card_inactive,
          //TM_CM_image                      : WU_PAYMENT_cash_active,
            TM_BA_image                      : WU_PAYMENT_bank_inactive,

            "viewTM_view_CM_isHidden"        : view_CM_isHidden, //DownClick_currency
            TM_CM_image                      : this.find_TM_CM_image(this.state.picker1_textFieldLabel1_id),
          });
          localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_send);
          localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
          localStorage.setItem("TransferOnline1_TransferMethod",this.find_TransferOnline1_TransferMethod(this.state.picker1_textFieldLabel1_id));
          localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);
          break;
        }
        else{
          this.setState({
            "picker3_selIndex_currencyReceive" :  i,
            "picker3_textFieldLabel1_id"       :  this.state.parserObject_getCurrencies[i].curr_iso_id,

            //reset
            "viewRN_isHidden"                : true,
            "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
            "textFieldYouSend"               : "",
            "textFieldYouSend_hasError"      : false,
            "textFieldYouSend_disabled"      : true,
          //"textFieldReceiverGets"          : "",
          //"textFieldReceiverGets_hasError" : false,
          //"textFieldReceiverGets_disabled" : true,
            PM_BT_image                      : WU_PAYMENT_bank_active,
            PM_CC_image                      : WU_PAYMENT_card_inactive,
          //TM_CM_image                      : WU_PAYMENT_cash_active,
            TM_BA_image                      : WU_PAYMENT_bank_inactive,

            "viewTM_view_CM_isHidden"        : view_CM_isHidden, //DownClick_currency
            TM_CM_image                      : this.find_TM_CM_image(this.state.picker1_textFieldLabel1_id),
          });
          localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_receive);
          localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
          localStorage.setItem("TransferOnline1_TransferMethod",this.find_TransferOnline1_TransferMethod(this.state.picker1_textFieldLabel1_id));
          localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);
          break;
        }
      }
    }
    if(view_CM_isHidden===true && view_BA_isHidden===true){
      this.dialog_handleOpen(this.NSInforString("TransferOnline_err_header_transferMethod"));
    }
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_arrows_act(event) {
    //if(api.print_logs){console.log("btn_arrows_act");}

    if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
      localStorage.setItem("TransferOnline1_type",api.TransferOnline1_type_receive);
      this.setState({
        TransferOnline1_type                                 : api.TransferOnline1_type_receive,
        textFieldYouSend                                     : "",
        textFieldYouSend_hasError                            : false,
        textFieldYouSend_disabled                            : true,
        textFieldReceiverGets                                : "",
        textFieldReceiverGets_hasError                       : false,
        textFieldReceiverGets_disabled                       : false,
        viewRN_isHidden                                      : true,
        btn_next_state                                       : this.NSInforString("TransferOnline_btn_calc"),
        PM_BT_image                                          : WU_PAYMENT_bank_active,
        PM_CC_image                                          : WU_PAYMENT_card_inactive,
        TM_CM_image                                          : WU_PAYMENT_cash_active,
        TM_BA_image                                          : WU_PAYMENT_bank_inactive,
      });
      localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_receive);
      localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
      localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Cash);
      localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);
    }
    else{
      localStorage.setItem("TransferOnline1_type",api.TransferOnline1_type_send);
      this.setState({
        TransferOnline1_type                                 : api.TransferOnline1_type_send,
        textFieldYouSend                                     : "",
        textFieldYouSend_hasError                            : false,
        textFieldYouSend_disabled                            : false,
        textFieldReceiverGets                                : "",
        textFieldReceiverGets_hasError                       : false,
        textFieldReceiverGets_disabled                       : true,
        viewRN_isHidden                                      : true,
        btn_next_state                                       : this.NSInforString("TransferOnline_btn_calc"),
        PM_BT_image                                          : WU_PAYMENT_bank_active,
        PM_CC_image                                          : WU_PAYMENT_card_inactive,
        TM_CM_image                                          : WU_PAYMENT_cash_active,
        TM_BA_image                                          : WU_PAYMENT_bank_inactive,
      });
      localStorage.setItem("TransferOnline1_type",          api.TransferOnline1_type_send);
      localStorage.setItem("TransferOnline1_PaymentMethod", api.TransferOnline1_PaymentMethod_BankTransfer);
      localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Cash);
      localStorage.setItem("promo_type_selected",           api.promo_type_selected_none);
    }

    //animation effect
    // setTimeout(function() { //Start the timer
    //   this.scrollToBottom();
    // }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  PM_BT_act(event) {
    //if(api.print_logs){console.log("PM_BT_act");}
    localStorage.setItem("TransferOnline1_PaymentMethod",api.TransferOnline1_PaymentMethod_BankTransfer);
    this.setState({
      "TransferOnline1_PaymentMethod" : api.TransferOnline1_PaymentMethod_BankTransfer,
      "PM_BT_image"                   : WU_PAYMENT_bank_active,
      "PM_CC_image"                   : WU_PAYMENT_card_inactive,
      "picker7_textFieldLabel1"       : this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1"),

      //reset
      "viewRN_isHidden"                : true,
      "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      // "textFieldYouSend"               : "",
      // "textFieldYouSend_hasError"      : false,
      // "textFieldYouSend_disabled"      : false,
      // "textFieldReceiverGets"          : "",
      // "textFieldReceiverGets_hasError" : false,
      // "textFieldReceiverGets_disabled" : true,
    });
    //issue20(13/04/20) we comment//try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  PM_CC_act(event) {
    //if(api.print_logs){console.log("PM_CC_act");}
    localStorage.setItem("TransferOnline1_PaymentMethod",api.TransferOnline1_PaymentMethod_CreditCard);
    this.setState({
      "TransferOnline1_PaymentMethod" : api.TransferOnline1_PaymentMethod_CreditCard,
      "PM_BT_image"                   : WU_PAYMENT_bank_inactive,
      "PM_CC_image"                   : WU_PAYMENT_card_active,
      "picker7_textFieldLabel1"       : this.NSInforString("TransferOnline_viewPM_lbl_CC_lb1"),

      //reset
      "viewRN_isHidden"                : true,
      "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      // "textFieldYouSend"               : "",
      // "textFieldYouSend_hasError"      : false,
      // "textFieldYouSend_disabled"      : false,
      // "textFieldReceiverGets"          : "",
      // "textFieldReceiverGets_hasError" : false,
      // "textFieldReceiverGets_disabled" : true,
    });
    //issue20(13/04/20) we comment//try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  TM_CM_act(event) {
    //if(api.print_logs){console.log("TM_CM_act");}
    localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Cash);
    this.setState({
      "TM_CM_image"             : WU_PAYMENT_cash_active,
      "TM_BA_image"             : WU_PAYMENT_bank_inactive,
      "picker6_textFieldLabel1" : this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1"),

      //reset
      "viewRN_isHidden"                : true,
      "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      // "textFieldYouSend"               : "",
      // "textFieldYouSend_hasError"      : false,
      // "textFieldYouSend_disabled"      : false,
      // "textFieldReceiverGets"          : "",
      // "textFieldReceiverGets_hasError" : false,
      // "textFieldReceiverGets_disabled" : true,
    });
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  TM_BA_act(event) {
    //if(api.print_logs){console.log("TM_BA_act");}
    localStorage.setItem("TransferOnline1_TransferMethod",api.TransferOnline1_TransferMethod_Bank);
    this.setState({
      "TransferOnline1_TransferMethod" : api.TransferOnline1_TransferMethod_Bank,
      "TM_CM_image"                    : WU_PAYMENT_cash_inactive,
      "TM_BA_image"                    : WU_PAYMENT_bank_active,
      "picker6_textFieldLabel1"        : this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1"),

      //reset
      "viewRN_isHidden"                : true,
      "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      // "textFieldYouSend"               : "",
      // "textFieldYouSend_hasError"      : false,
      // "textFieldYouSend_disabled"      : false,
      // "textFieldReceiverGets"          : "",
      // "textFieldReceiverGets_hasError" : false,
      // "textFieldReceiverGets_disabled" : true,
    });
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
        if(this.state.picker1_textFieldLabel1_text ==="") { this.setState({"picker1_textFieldLabel1_hasError" : true }); emptyFields = true; } //picker1_textFieldLabel1_AUTOCOMPLETE_MODE(do not trim)
        if(this.state.picker3_textFieldLabel1_id ==="")   { this.setState({"picker3_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.textFieldYouSend.trim() === "")     { this.setState({"textFieldYouSend_hasError"        : true }); emptyFields = true; }
      }
      else{
        if(this.state.picker1_textFieldLabel1_text ==="") { this.setState({"picker1_textFieldLabel1_hasError" : true }); emptyFields = true; } //picker1_textFieldLabel1_AUTOCOMPLETE_MODE(do not trim)
        if(this.state.picker3_textFieldLabel1_id ==="")   { this.setState({"picker3_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.textFieldReceiverGets.trim() === ""){ this.setState({"textFieldReceiverGets_hasError"   : true }); emptyFields = true; }
      }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //----------------
    //validate country
    //----------------
    //let destCountryID = this.state.picker1_textFieldLabel1_id;
    if(this.state.picker1_textFieldLabel1_text ===""){ //picker1_textFieldLabel1_AUTOCOMPLETE_MODE(do not trim)
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_pic1"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate State
    //--------------
    if(this.state.viewState_isHidden === false){
      let state_id = this.state.picker4_textFieldLabel1_id;
      if(state_id === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_picker4_title"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    }
    //-------------
    //validate City
    //-------------
    if(this.state.viewCity_isHidden === false){
      let city_id = this.state.picker5_textFieldLabel1_id;
      if(city_id === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_picker5_title"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    }
    //----------------------
    //validate dest currency
    //----------------------
    let destCurrId = this.state.picker3_textFieldLabel1_id;
    if(destCurrId === ""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_picker3_title"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //-------------
    //validate posa
    //-------------
    let amountToSend    = "";
    let amountToReceive = "";
    if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
      amountToSend    = this.state.textFieldYouSend.trim();
      amountToReceive = this.state.textFieldReceiverGets.trim();
      if(amountToSend === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline_plh3")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      let aRex = aRegex;//  /^\d{0,9}(?:\.\d{0,2}){0,1}$/;
      if(aRex.test(amountToSend)===false){
        this.dialog_handleOpen(this.NSInforString("NotValidAmount"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    }
    else{
      amountToSend    = this.state.textFieldYouSend.trim();
      amountToReceive = this.state.textFieldReceiverGets.trim();
      if(amountToReceive === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline_plh4")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      let aRex = aRegex;//  /^\d{0,9}(?:\.\d{0,2}){0,1}$/;
      if(aRex.test(amountToReceive)===false){
        this.dialog_handleOpen(this.NSInforString("NotValidAmount"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    }
    //------------------------
    //validate source currency
    //------------------------
    let origCurrId = this.state.picker2_textFieldLabel1_id;
    if(origCurrId === ""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("currency"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //-----------------------
    //validate Payment Method
    //-----------------------
    if(localStorage.getItem("TransferOnline1_PaymentMethod") === api.TransferOnline1_PaymentMethod_None){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("payment_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //------------------------
    //validate Transfer Method
    //------------------------
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_None){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //console.log("this.state.viewTM_view_CM_isHidden="+this.state.viewTM_view_CM_isHidden);
    //console.log("this.state.viewTM_view_BA_isHidden="+this.state.viewTM_view_BA_isHidden);
    if(this.state.viewTM_view_CM_isHidden===true && this.state.viewTM_view_BA_isHidden===true){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //console.log("this.state.TM_CM_image="+this.state.TM_CM_image);
    //console.log("this.state.TM_BA_image="+this.state.TM_BA_image);
    if(this.state.TM_CM_image===WU_PAYMENT_cash_inactive && this.state.TM_BA_image===WU_PAYMENT_bank_inactive){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_next_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
        if(this.state.picker1_textFieldLabel1_text ==="") { this.setState({"picker1_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.picker3_textFieldLabel1_id ==="")   { this.setState({"picker3_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.textFieldYouSend.trim() === "")     { this.setState({"textFieldYouSend_hasError"        : true }); emptyFields = true; }
      }
      else{
        if(this.state.picker1_textFieldLabel1_text ==="") { this.setState({"picker1_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.picker3_textFieldLabel1_id ==="")   { this.setState({"picker3_textFieldLabel1_hasError" : true }); emptyFields = true; }
        if(this.state.textFieldReceiverGets.trim() === ""){ this.setState({"textFieldReceiverGets_hasError"   : true }); emptyFields = true; }
      }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //----------------
    //validate country
    //----------------
    let destCountryID = this.state.picker1_textFieldLabel1_id;
    if(this.state.picker1_textFieldLabel1_text ===""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_pic1"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //--------------
    //validate State
    //--------------
    if(this.state.viewState_isHidden === false){
      let state_id = this.state.picker4_textFieldLabel1_id;
      if(state_id === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_picker4_title"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    }
    //-------------
    //validate City
    //-------------
    if(this.state.viewCity_isHidden === false){
      let city_id = this.state.picker5_textFieldLabel1_id;
      if(city_id === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_picker5_title"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
    }
    //----------------------
    //validate dest currency
    //----------------------
    let destCurrId = this.state.picker3_textFieldLabel1_id;
    if(destCurrId === ""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline_picker3_title"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //-------------
    //validate posa
    //-------------
    let amountToSend    = "";
    let amountToReceive = "";
    if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
      amountToSend    = this.state.textFieldYouSend.trim();
      amountToReceive = this.state.textFieldReceiverGets.trim();
      if(amountToSend === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline_plh3")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      let aRex = aRegex;//  /^\d{0,9}(?:\.\d{0,2}){0,1}$/;
      if(aRex.test(amountToSend)===false){
        this.dialog_handleOpen(this.NSInforString("NotValidAmount"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(api.print_logs){console.log("amountToSend    = "+amountToSend);}
      if(api.print_logs){console.log("amountToReceive = "+amountToReceive);}
      amountToSend    = amountToSend.replace(',', '.');
      amountToReceive = amountToReceive.replace(',', '.');
    }
    else{
      amountToSend    = this.state.textFieldYouSend.trim();
      amountToReceive = this.state.textFieldReceiverGets.trim();
      if(amountToReceive === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline_plh4")+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      let aRex = aRegex;//  /^\d{0,9}(?:\.\d{0,2}){0,1}$/;
      if(aRex.test(amountToReceive)===false){
        this.dialog_handleOpen(this.NSInforString("NotValidAmount"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
      }
      if(api.print_logs){console.log("amountToSend    = "+amountToSend);}
      if(api.print_logs){console.log("amountToReceive = "+amountToReceive);}
      amountToSend    = amountToSend.replace(',', '.');
      amountToReceive = amountToReceive.replace(',', '.');
    }
    //------------------------
    //validate source currency
    //------------------------
    let origCurrId = this.state.picker2_textFieldLabel1_id;
    if(origCurrId === ""){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("currency"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //-----------------------
    //validate Payment Method
    //-----------------------
    if(localStorage.getItem("TransferOnline1_PaymentMethod") === api.TransferOnline1_PaymentMethod_None){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("payment_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //------------------------
    //validate Transfer Method
    //------------------------
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_None){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(api.print_logs){console.log("this.state.viewTM_view_CM_isHidden="+this.state.viewTM_view_CM_isHidden);}
    if(api.print_logs){console.log("this.state.viewTM_view_BA_isHidden="+this.state.viewTM_view_BA_isHidden);}
    if(this.state.viewTM_view_CM_isHidden===true && this.state.viewTM_view_BA_isHidden===true){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.viewTM_view_CM_isHidden===false && this.state.viewTM_view_BA_isHidden===true && this.state.TM_CM_image===WU_PAYMENT_cash_inactive){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //console.log("this.state.TM_CM_image="+this.state.TM_CM_image);
    //console.log("this.state.TM_BA_image="+this.state.TM_BA_image);
    if(this.state.TM_CM_image===WU_PAYMENT_cash_inactive && this.state.TM_BA_image===WU_PAYMENT_bank_inactive){
      this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("transfer_method"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    if(this.state.btn_next_state === this.NSInforString("TransferOnline_btn_calc")){
      this.calculateFeeInquiryMultiple();
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    else{
      localStorage.setItem("TransferOnline1_PaymentMethod_str",     this.state.picker7_textFieldLabel1);
      localStorage.setItem("TransferOnline1_TransferMethod_str",    this.state.picker6_textFieldLabel1);
      localStorage.setItem("TransferOnline1_amountToSend",          amountToSend);
      localStorage.setItem("TransferOnline1_amountToReceive",       amountToReceive);
      localStorage.setItem("TransferOnline1_selCountry",            JSON.stringify(this.state.parserObject_getCountries[this.state.picker1_selIndex]));
      localStorage.setItem("TransferOnline1_selCountry_ctry_wu_id", destCountryID); //SOS XXX ???: Convert Code

      if(this.state.viewState_isHidden){localStorage.setItem("TransferOnline1_selState", "");}
      else                             {localStorage.setItem("TransferOnline1_selState", JSON.stringify(this.state.parserObject_getStates[this.state.picker4_selIndex_State]));}
      if(this.state.viewCity_isHidden) {localStorage.setItem("TransferOnline1_selCity",  "");}
      else                             {localStorage.setItem("TransferOnline1_selCity",  JSON.stringify(this.state.parserObject_getCities[this.state.picker5_selIndex_City]));}
  // mainDelegate.TransferOnline1_selCurrencyOrig       = [mainDelegate.parserObject_getCurrencies4CountrySend objectAtIndex:picker2_selIndex_currencySend];
     localStorage.setItem("TransferOnline1_selCurrencyDest",        JSON.stringify(this.state.parserObject_getCurrencies[this.state.picker3_selIndex_currencyReceive]));

      //if(api.print_logs){console.log('TransferOnline1_selCountry='+localStorage.getItem("TransferOnline1_selCountry"));}
      this.makeHTTPConn_next();
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_next(){
    let methName = filename+"makeHTTPConn_next ";
    if(api.print_logs){console.log(methName);}

      if(localStorage.getItem("isLoggedIn")==="true"){
        //---------------------
        //newCustomer filtering---After Calculation---Exclude(LIGHT,BP)
        //---------------------
        if(api.new_registration_enabled){
          let parserObject_validatecustomer = {};
          try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
          let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
          if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
          if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
        }
        //+++++++++++++++
        //Goto Controller
        //+++++++++++++++
        localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
        history.push(wu_Utilities.getNavigationURLs("TransferOnline2"));
      }
      else{
        //+++++++++++++++++++
        //TransferOnlineLogin
        //+++++++++++++++++++
        localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
        history.push(wu_Utilities.getNavigationURLs("TransferOnlineLogin"));
      }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  calculateFeeInquiryMultiple(){
    let methName = filename+"calculateFeeInquiryMultiple ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_send){
        let orig_ctry_wu              = "GR";
        let orig_curr                 = "EUR";
        let dest_ctry_wu              = this.state.picker1_textFieldLabel1_id;
        let dest_curr                 = this.state.picker3_textFieldLabel1_id;
        let amount_to_send            = this.state.textFieldYouSend.trim().replace(',', '.');
        let payout_amount             = "";//this.state.textFieldReceiverGets.trim();
        let calculate_based_on_payout = "false";
        let cardNo                    = "";
        let promoCode                 = this.state.textField100.trim();
        let cardPromoCode             = "";

        if(!wu_Utilities.validateFloatString(wu_Utilities.convert2FloatString(amount_to_send))){
          this.dialog_handleOpen(this.NSInforString("NotValidAmount"));
          this.stopLockers();
          return;
        }

        if(orig_ctry_wu   === null){orig_ctry_wu   = "";}
        if(orig_curr      === null){orig_curr      = "";}
        if(dest_ctry_wu   === null){dest_ctry_wu   = "";}
        if(dest_curr      === null){dest_curr      = "";}
        if(amount_to_send === null){amount_to_send = "";}
        if(payout_amount  === null){payout_amount  = "";}

        let parserObject_getfeeinquirymultiple_req = {};
        parserObject_getfeeinquirymultiple_req["orig_ctry_wu"]              = orig_ctry_wu;
        parserObject_getfeeinquirymultiple_req["orig_curr"]                 = orig_curr;
        parserObject_getfeeinquirymultiple_req["dest_ctry_wu"]              = dest_ctry_wu;
        parserObject_getfeeinquirymultiple_req["dest_curr"]                 = dest_curr;
        parserObject_getfeeinquirymultiple_req["amount_to_send"]            = amount_to_send;
        parserObject_getfeeinquirymultiple_req["payout_amount"]             = payout_amount;
        parserObject_getfeeinquirymultiple_req["calculate_based_on_payout"] = calculate_based_on_payout;
        parserObject_getfeeinquirymultiple_req["cardNo"]                    = cardNo;
        parserObject_getfeeinquirymultiple_req["promoCode"]                 = promoCode;
        parserObject_getfeeinquirymultiple_req["cardPromoCode"]             = cardPromoCode;
        parserObject_getfeeinquirymultiple_req["txnChannelTypes"]           = (localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer) ? "OnlineMT_Bank" : "OnlineMT_Card";
        parserObject_getfeeinquirymultiple_req["recaptchaVerify"]           = api.isCaptchaEnabled ? JSON.stringify(this.recaptchaRef.getResponse()) : "";

        let orig_ctry_wu_FULL = (orig_ctry_wu === "") ? false : true;
        let orig_curr_FULL    = (orig_curr    === "") ? false : true;
        let dest_ctry_wu_FULL = (dest_ctry_wu === "") ? false : true;
        let dest_curr_FULL    = (dest_curr    === "") ? false : true;
        let amoumt_FULL       = ((amount_to_send === "") && (payout_amount === ""))? false : true;

        if(orig_ctry_wu_FULL && orig_curr_FULL && dest_ctry_wu_FULL && dest_curr_FULL && amoumt_FULL){
          let wu_feeinquirymultiple_START=new Date(); this.startSpinners();
          setTimeout(function() { //Start the timer
            //------------------
            //feeinquirymultiple
            //------------------
            wu_FeeInquiryService
            .wu_feeinquirymultiple(parserObject_getfeeinquirymultiple_req)
            .then(res => {
              if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
              this.stopLockers();this.stopSpinners();
              if(res.returnCode===0){
                this.setState({
                  "btn_next_state"                     : this.NSInforString("TransferOnline_btn_next"),
                  "parserObject_getfeeinquirymultiple" : res
                });
                this.setup_Expenses_and_global_promo();
              }
            })
            .catch(err => {
              let wu_feeinquirymultiple_dur=wu_Utilities.diffDatesSec(wu_feeinquirymultiple_START);console.log(methName+"wu_feeinquirymultiple_dur="+wu_feeinquirymultiple_dur);
              this.stopLockers();this.stopSpinners();
              console.log(methName+"err="+JSON.stringify(err));
              if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
              else if(wu_feeinquirymultiple_dur>=59)         { this.dialog_handleOpen(this.NSInforString("networkerror")+"...","NET"); }
              else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
            });
          }.bind(this), 500)
        }
    }
    else if(localStorage.getItem("TransferOnline1_type") === api.TransferOnline1_type_receive){
        let orig_ctry_wu              = "GR";
        let orig_curr                 = "EUR";
        let dest_ctry_wu              = this.state.picker1_textFieldLabel1_id;
        let dest_curr                 = this.state.picker3_textFieldLabel1_id;
        let amount_to_send            = "";//this.state.textFieldYouSend.trim();
        let payout_amount             = this.state.textFieldReceiverGets.trim().replace(',', '.');
        let calculate_based_on_payout = "true";
        let cardNo                    = "";
        let promoCode                 = this.state.textField100.trim();
        let cardPromoCode             = "";

        if(!wu_Utilities.validateFloatString(wu_Utilities.convert2FloatString(payout_amount))){
          this.dialog_handleOpen(this.NSInforString("NotValidAmount"));
          this.stopLockers();
          return;
        }

        if(orig_ctry_wu   === null){orig_ctry_wu   = "";}
        if(orig_curr      === null){orig_curr      = "";}
        if(dest_ctry_wu   === null){dest_ctry_wu   = "";}
        if(dest_curr      === null){dest_curr      = "";}
        if(amount_to_send === null){amount_to_send = "";}
        if(payout_amount  === null){payout_amount  = "";}

        let parserObject_getfeeinquirymultiple_req = {};
        parserObject_getfeeinquirymultiple_req["orig_ctry_wu"]              = orig_ctry_wu;
        parserObject_getfeeinquirymultiple_req["orig_curr"]                 = orig_curr;
        parserObject_getfeeinquirymultiple_req["dest_ctry_wu"]              = dest_ctry_wu;
        parserObject_getfeeinquirymultiple_req["dest_curr"]                 = dest_curr;
        parserObject_getfeeinquirymultiple_req["amount_to_send"]            = amount_to_send;
        parserObject_getfeeinquirymultiple_req["payout_amount"]             = payout_amount;
        parserObject_getfeeinquirymultiple_req["calculate_based_on_payout"] = calculate_based_on_payout;
        parserObject_getfeeinquirymultiple_req["cardNo"]                    = cardNo;
        parserObject_getfeeinquirymultiple_req["promoCode"]                 = promoCode;
        parserObject_getfeeinquirymultiple_req["cardPromoCode"]             = cardPromoCode;
        parserObject_getfeeinquirymultiple_req["txnChannelTypes"]           = (localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer) ? "OnlineMT_Bank" : "OnlineMT_Card";
        parserObject_getfeeinquirymultiple_req["recaptchaVerify"]           = api.isCaptchaEnabled ? JSON.stringify(this.recaptchaRef.getResponse()) : "";

        let orig_ctry_wu_FULL = (orig_ctry_wu === "") ? false : true;
        let orig_curr_FULL    = (orig_curr    === "") ? false : true;
        let dest_ctry_wu_FULL = (dest_ctry_wu === "") ? false : true;
        let dest_curr_FULL    = (dest_curr    === "") ? false : true;
        let amoumt_FULL       = ((amount_to_send === "") && (payout_amount === ""))? false : true;

        if(orig_ctry_wu_FULL && orig_curr_FULL && dest_ctry_wu_FULL && dest_curr_FULL && amoumt_FULL){
          let wu_feeinquirymultiple_START=new Date(); this.startSpinners();
          setTimeout(function() { //Start the timer
            //------------------
            //feeinquirymultiple
            //------------------
            wu_FeeInquiryService
            .wu_feeinquirymultiple(parserObject_getfeeinquirymultiple_req)
            .then(res => {
              if(localStorage.getItem("curr_view").trim()!=="TransferOnline1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
              this.stopLockers();this.stopSpinners();
              if(res.returnCode===0){
                this.setState({
                  "btn_next_state"                     : this.NSInforString("TransferOnline_btn_next"),
                  "parserObject_getfeeinquirymultiple" : res
                });
                this.setup_Expenses_and_global_promo();
              }
            })
            .catch(err => {
              let wu_feeinquirymultiple_dur=wu_Utilities.diffDatesSec(wu_feeinquirymultiple_START);console.log(methName+"wu_feeinquirymultiple_dur="+wu_feeinquirymultiple_dur);
              this.stopLockers();this.stopSpinners();
              console.log(methName+"err="+JSON.stringify(err));
              if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
              else if(wu_feeinquirymultiple_dur>=59)         { this.dialog_handleOpen(this.NSInforString("networkerror")+"...","NET"); }
              else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
            });
          }.bind(this), 500)
        }
    }
  }
  //----------------------------------------------------------------------------------------------------
  setup_Expenses_and_global_promo(){
    let methName = filename+"setup_Expenses_and_global_promo ";
    if(api.print_logs){console.log(methName);}

    let item = null; //{}
    //-------------------------
    //promo_type_selected_promo
    //-------------------------
    if(localStorage.getItem("promo_type_selected") === api.promo_type_selected_promo) {
        // item = [self promo_find_promoCode_item];
        //
        // mainDelegate.promo_sendoutbound     = [textField100.text stringByTrimmingCharactersInSet:[NSCharacterSet whitespaceAndNewlineCharacterSet]];
        // mainDelegate.promo_validateoutbound = [textField100.text stringByTrimmingCharactersInSet:[NSCharacterSet whitespaceAndNewlineCharacterSet]];
    }
    //------------------------
    //promo_type_selected_card
    //------------------------
    if(localStorage.getItem("promo_type_selected") === api.promo_type_selected_card) {
        // item = [self promo_find_cardPromoCode_item];
        //
        // let cardPromoCode = "";
        //
        // mainDelegate.promo_sendoutbound     = cardPromoCode;
        // mainDelegate.promo_validateoutbound = cardPromoCode;
    }
    //------------------------
    //promo_type_selected_none
    //------------------------
    if(localStorage.getItem("promo_type_selected") === api.promo_type_selected_none) {
        item = this.promo_find_default_item();
        if(api.print_logs){console.log(methName+item);}
        localStorage.setItem("promo_sendoutbound",           "");
        localStorage.setItem("promo_validateoutbound",       "");
    }

    //Revamp
    localStorage.setItem("promo_sendoutbound",           this.state.textField100.trim());
    localStorage.setItem("promo_validateoutbound",       this.state.textField100.trim());


    //item["discount"] = -1.5;

    let ws_amount_to_send = 0.0;
    let ws_charges        = 0.0;
    let ws_discount       = 0.0;
  //let ws_fx_rate        = 0.0;
    let ws_payout_amount  = 0.0;
    try { ws_amount_to_send = parseFloat(item["amount_to_send"]); }catch (err){ ws_amount_to_send = 0.0; }
    try { ws_charges        = parseFloat(item["charges"]);        }catch (err){ ws_charges        = 0.0; }
    try { ws_discount       = parseFloat(item["discount"]);       }catch (err){ ws_discount       = 0.0; }
  //try { ws_fx_rate        = parseFloat(item["fx_rate"]);        }catch (err){ ws_fx_rate        = 0.0; }
    try { ws_payout_amount  = parseFloat(item["payout_amount"]);  }catch (err){ ws_payout_amount  = 0.0; }

    //FORMAT 10000.00
    // //let destCurr = this.state.picker3_textFieldLabel1_text;
    // let viewExp_lbl_val1 = ws_amount_to_send.toFixed(2)+" EUR";
    // let viewExp_lbl_val2 = (item["discount"]===null) ? ws_charges.toFixed(2)+" EUR" : (ws_charges+ws_discount).toFixed(2)+" EUR";
    // let viewExp_lbl_val3 = (item["discount"]===null) ? " - " : ws_discount.toFixed(2)+" EUR";
    // let viewExp_lbl_val4 = (ws_amount_to_send+ws_charges).toFixed(2)+" EUR";

    //FORMAT 10.000,00
    //let destCurr = this.state.picker3_textFieldLabel1_text;
    let viewExp_lbl_val1 = this.comvert2ProperAmountFormat(ws_amount_to_send.toFixed(2))+" EUR";
    let viewExp_lbl_val2 = (item["discount"]===null) ? this.comvert2ProperAmountFormat(ws_charges.toFixed(2))+" EUR" : this.comvert2ProperAmountFormat((ws_charges+ws_discount).toFixed(2))+" EUR";
    let viewExp_lbl_val3 = (item["discount"]===null) ? this.comvert2ProperAmountFormat("0.00")+" EUR"                : this.comvert2ProperAmountFormat(ws_discount.toFixed(2))+" EUR";
    let viewExp_lbl_val3_show = (item["discount"]===null) ? false : true;
    let viewExp_lbl_val4 = this.comvert2ProperAmountFormat((ws_amount_to_send+ws_charges).toFixed(2))+" EUR";

    this.setState({
      "textFieldYouSend"      : ws_amount_to_send.toFixed(2).replace('.',','),
      "textFieldReceiverGets" : ws_payout_amount.toFixed(2).replace('.',','),
      "viewRN_isHidden"       : false,
      "viewExp_lbl_val1"      : viewExp_lbl_val1,
      "viewExp_lbl_val2"      : viewExp_lbl_val2,
      "viewExp_lbl_val3"      : viewExp_lbl_val3,
      "viewExp_lbl_val3_show" : viewExp_lbl_val3_show,
      "viewExp_lbl_val4"      : viewExp_lbl_val4,
    });

//     if(mainDelegate.promo_type_selected == promo_type_selected_none){
// //        viewE_lbl_val3.text = @" - ";
//         viewExp_lbl_val3.text = @" - ";
//     }

    //animation effect
    // setTimeout(function() { //Start the timer
    //   this.scrollToBottom();
    // }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  promo_find_default_item(){
    let methName = filename+"promo_find_default_item ";
    if(api.print_logs){console.log(methName);}

    let aItem      = null; //{}
    let feeInquiry = null; //[]
    try { feeInquiry = this.state.parserObject_getfeeinquirymultiple["feeInquiry"]; }catch (err) { feeInquiry = null; }
    for(let i=0; i<feeInquiry.length; ++i){
        aItem = feeInquiry[i];
        let serviceName = "";
        try { serviceName = aItem["serviceName"]; }catch (err) { serviceName = ""; }
        if( serviceName === null ){serviceName = ""; }
        if(serviceName === "DIRECT TO BANK"   && localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
            return aItem;
        }
        if(serviceName === "MONEY IN MINUTES" && localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Cash){
            return aItem;
        }
    }
    if(feeInquiry.length>0){
        aItem = feeInquiry[0];
    }

    return aItem;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="textFieldYouSend"){
      localStorage.setItem("TransferOnline1_type",api.TransferOnline1_type_send);
      //let eventTMP = event.target.value;
      let aRex     = aRegex;//  /^\d{0,9}(?:\.\d{0,2}){0,1}$/;
      //console.log("eventTMP=['+eventTMP+"]" + " regex=["+aRex.test(eventTMP)+"]");
      eventTMP = this.maskaPoswn(eventTMP);
      this.setState({
        "TransferOnline1_type"           : api.TransferOnline1_type_send,
        "textFieldYouSend"               : eventTMP,
        "textFieldYouSend_hasError"      : (eventTMP.trim() === "") ? true : false,
        "textFieldReceiverGets"          : "",
        "textFieldReceiverGets_hasError" : false,
        //reset
        "viewRN_isHidden"                : true,
        "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      //"textFieldYouSend"               : "",
      //"textFieldYouSend_hasError"      : false,
      //"textFieldYouSend_disabled"      : false,
      //"textFieldReceiverGets"          : "",
      //"textFieldReceiverGets_hasError" : false,
      //"textFieldReceiverGets_disabled" : true,
      });
      if(eventTMP.length>0 && aRex.test(eventTMP)===false){ this.Snackbar_textField_handleOpen(this.NSInforString("NotValidAmount")); this.setState({"textFieldYouSend_hasError":true}); return; }
    }
    else if(stateVar==="textFieldReceiverGets"){
      localStorage.setItem("TransferOnline1_type",api.TransferOnline1_type_receive);
      //let eventTMP = event.target.value;
      let aRex     = aRegex;//  /^\d{0,9}(?:\.\d{0,2}){0,1}$/;
      //console.log("eventTMP=['+eventTMP+"]" + " regex=["+aRex.test(eventTMP)+"]");
      eventTMP = this.maskaPoswn(eventTMP);
      this.setState({
        "TransferOnline1_type"           : api.TransferOnline1_type_receive,
        "textFieldYouSend"               : "",
        "textFieldYouSend_hasError"      : false,
        "textFieldReceiverGets"          : eventTMP,
        "textFieldReceiverGets_hasError" : (eventTMP.trim() === "") ? true : false,
        //reset
        "viewRN_isHidden"                : true,
        "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      //"textFieldYouSend"               : "",
      //"textFieldYouSend_hasError"      : false,
      //"textFieldYouSend_disabled"      : false,
      //"textFieldReceiverGets"          : "",
      //"textFieldReceiverGets_hasError" : false,
      //"textFieldReceiverGets_disabled" : true,
      });
      if(eventTMP.length>0 && aRex.test(eventTMP)===false){ this.Snackbar_textField_handleOpen(this.NSInforString("NotValidAmount")); this.setState({"textFieldReceiverGets_hasError":true}); return; }
    }
    else if(stateVar==="textField100"){
      //let eventTMP = event.target.value;
      this.setState({
        "textField100"                   : eventTMP,
        //reset
        "viewRN_isHidden"                : true,
        "btn_next_state"                 : this.NSInforString("TransferOnline_btn_calc"),
      //"textFieldYouSend"               : "",
      //"textFieldYouSend_hasError"      : false,
      //"textFieldYouSend_disabled"      : false,
      //"textFieldReceiverGets"          : "",
      //"textFieldReceiverGets_hasError" : false,
      //"textFieldReceiverGets_disabled" : true,
      });
    }
    else{
      this.setState({ [stateVar] : event.target.value });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN") { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  scrollToBottom(){
    //if(api.print_logs){console.log("scrollToBottom");}
    //document.getElementById('scrollHere2').scrollIntoView();

    //console.log("scrollToBottom "+document.body.scrollHeight);
    //window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });

    //document.getElementById('scrollHere2').scrollIntoView({ behavior: 'smooth' });
    //document.getElementById("scrollHere2").scroll(0,100)
  }
  //----------------------------------------------------------------------------------------------------
  maskaPoswn(eventTMP){
    //step-1
    eventTMP = eventTMP.replace(/[^\d,]/g, '');
    //step-2
    let count = (eventTMP.match(/,/g) || []).length;
    if(count>1){
      //console.log("count="+count);
      //eventTMP = eventTMP.replace(/\.\./g, '.');
      eventTMP = eventTMP.replace(',', '');
    }
    //step-3
    if(eventTMP.indexOf(",")>=0) {
      let NumOfDec = eventTMP.length-eventTMP.indexOf(",")-1;
      //console.log("NumOfDec="+NumOfDec);
      if(NumOfDec>2){
        eventTMP = eventTMP.substring(0, eventTMP.length-1);
      }
    }
    return eventTMP;
  }
  //----------------------------------------------------------------------------------------------------
  maskaPoswn_dot(eventTMP){
    //step-1
    eventTMP = eventTMP.replace(/[^\d.]/g, '');
    //step-2
    let count = (eventTMP.match(/\./g) || []).length;
    if(count>1){
      //console.log("count="+count);
      //eventTMP = eventTMP.replace(/\.\./g, '.');
      eventTMP = eventTMP.replace('.', '');
    }
    //step-3
    if(eventTMP.indexOf(".")>=0) {
      let NumOfDec = eventTMP.length-eventTMP.indexOf(".")-1;
      //console.log("NumOfDec="+NumOfDec);
      if(NumOfDec>2){
        eventTMP = eventTMP.substring(0, eventTMP.length-1);
      }
    }
    return eventTMP;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups checkAppVersion----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_checkAppVersion_isOpen" : true,
        "dialog_checkAppVersion_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_btn_ok(){
    window.location.reload(true);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( TransferOnline1_continue_locked===true ){ return true;  }
    else                                        { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    TransferOnline1_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    TransferOnline1_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Promo---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  WU_FORM_promo_openclose_act(){
    if(this.state.promo_isHidden===true){ this.setState({ "promo_isHidden" : false, "WU_FORM_promo_openclose_img":WU_FORM_add_minus_retract }); }
    else                                { this.setState({ "promo_isHidden" : true,  "WU_FORM_promo_openclose_img":WU_FORM_add_plus_expand });  }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[FAB]---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  fab_Click2CallAction(){
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.dialog100_handleOpen(""); }
    else                                      { window.open(api.helpdeskURL, "Live Support", "toolbar=0,status=0,width=548,height=325"); }
    //nailed for TESTING:START---inactive
    //window.open(api.helpdeskURL, "Live Support", "toolbar=0,status=0,width=548,height=325");
    //nailed for TESTING:END
  }
  dialog100_handleOpen(dialog_msg){
    this.setState({ "dialog100_isOpen" : true });
    this.setState({ "dialog100_msg"    : dialog_msg });
  }
  dialog100_handleClose(){
    this.setState({ "dialog100_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  removeNonWuCountries(countries){
    let countriesNew = [];
    for(let i=0; i<countries.length; ++i){
      if(countries[i].isWu===true){countriesNew.push(countries[i]); /*console.log(countries[i].descr_en);*/}
    }
    if(countriesNew.length===0){return countries;}
    return countriesNew;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"TO1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
}
TransferOnline1.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TransferOnline1Style)(TransferOnline1)
);
